import { createContext } from 'react';
import { ComponentProps } from './RFPComponent.types';

const serverDataProps: ComponentProps = {
  jsonContent: {},
};

export const serverData = createContext(serverDataProps);
